<template>
  <div>
    <modals-container name="modal1" />
    <v-dialog />
    <!--资料设置-->
    <!--标题-->
    <p class="fav_mainHead">
      资料设置
      <a style="font-size: 14px; float: right; cursor: pointer; color: #E72B12;" @click="showInfo">
        <i class="el-icon-edit-outline"></i>&nbsp;完善个人资料
      </a>
    </p>
    <!--内容-->
    <div class="form_list">
      <div class="flex">
        <div class="form_img">
          <img src="@/assets/images/form_one.png" />
        </div>
        <span class="font16">用户名：<span v-if="user && user.username">{{ user.username }}</span></span>
      </div>
    </div>
    <div class="form_list">
      <div class="flex">
        <div class="form_img">
          <img src="@/assets/images/form_one.png" />
        </div>
        <span class="font16">昵称：<span v-if="user && user.nickname">{{ user.nickname }}</span><span
            v-if="!user || !user.nickname">游客</span></span>
      </div>
      <a class="form_modify" href="javascript:void(0);" @click="changeNickname">
        修改
      </a>
    </div>
    <div class="form_list">
      <div class="flex">
        <div class="form_img">
          <img src="@/assets/images/form_three.png" />
        </div>
        <div class="flex_column">
          <span class="font16">密码</span>
          <span class="fontFourteen color_777">用于保护账号信息和登录安全</span>
        </div>
      </div>
      <a class="form_modify" href="javascript:void(0);" @click="changePwd">
        修改
      </a>
    </div>
    <div class="rdiv pt10" style="padding-left: 35px; padding-right: 16px;">
      <UploadOSS :uploadOSSConf="uploadOSSConf" :DOM_ID="'head'" v-if="uploadOSSConf.STS != null"
        @success="OSSUploadSuccess"></UploadOSS>
      <img v-if="user.head && user.head !== ''" :src="user.head" width="151" height="151"
        style="position: absolute; left: 220px; top: 10px;" />
      <p class="mt10"><span class="tips_text">建议图片长151px宽151px，支持jpg、jpeg、png，图片大小不超过2MB</span></p>
    </div>
    <!--/资料设置-->
  </div>
</template>
<script>
import api from '@/api/index'
import config from '@/config/index'
import utils from '@/utils'
import UploadOSS from '@/components/common/upload/uploadOSS.vue'
import $ from 'jquery'
import { saveCookie, getCookie } from '@/store/cookies'
import ModalBox from '@/components/common/modal/index.vue'
import rangeManip from '@/components/byl/rangeManip/index.vue'
import InfoBox from '@/components/byl/InfoBox/index.vue'
import Bus from '@/utils/bus'
import { mapState, mapActions } from 'vuex'


const passwordMsg = "密码长度不小于8位, 包含大写字母、小写字母、数字、特殊字符其中三种"

export default {
  components: { UploadOSS },
  data() {
    return {
      uploadOSSConf: { showMode: '1', style: 'img_upload4', typeArr: 'image/png,image/jpg,image/jpeg', catalog: 'byl', fileName: '', maxSize: '2000000', STS: null }
    }
  },
  created() {
  },
  mounted() {
    this.getSTS()
    this.OSSUploadSuccess()
  },
  computed: {
    ...mapState('auth', ['user'])
  },
  methods: {
    ...mapActions('orgstructure', {
      addPerson: 'addPerson'
    }),
    ...mapActions('auth', {
      getMemberByUserId: 'getMemberByUserId'
    }),
    confirmBox(o) {
      var that = this
      this.$modal.show('dialog', {
        title: o.title,
        text: o.text,
        buttons: [
          {
            title: '确认',
            default: true,
            handler: utils.debounce(() => {
              if (o.yes && o.yes instanceof Function) {
                o.yes()
                that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
              }
            }, 1000)
          },
          {
            title: '取消'
          }
        ]
      })
    },
    changePwd() {
      var that = this
      this.confirmBox({
        title: '修改密码',
        text: '<input id="uc-pwd" type="password" placeholder="密码长度不能小于8位" class="put_495" style="width: 250px;" minlength="8" />',
        yes: function () {
          var o = {
            password: $('#uc-pwd').val(),
            userId: that.user.id
          }
          if (o.password.length < 8) {
            that.$toasted.show('密码长度不能小于8位')
          } else {
            api.post(config.bylBaseCenterPath, '/user/edit/password', o, function (r) { // 正常
              that.$toasted.show('修改密码成功')
              that.$modal.hide('dialog')
            })
          }
        }
      })
    },
    changeNickname() {
      var that = this
      this.confirmBox({
        title: '修改昵称',
        text: '<input id="uc-nickname" type="text" class="put_495" style="width: 250px;" />',
        yes: function () {
          var o = {
            nickname: $('#uc-nickname').val()
          }
          api.post(config.bylBaseCenterPath, '/user/edit/' + that.user.id, o, function (r) { // 正常
            that.$toasted.show('修改昵称成功')
            var u = getCookie('user')
            u.nickname = o.nickname
            saveCookie('user', u)
            that.user.nickname = o.nickname
            that.$modal.hide('dialog')
          })
        }
      })
    },
    updateAvatar(path) {
      var that = this
      api.post(config.bylBaseCenterPath, '/user/uploading', { path: path }, function (r) { // 正常
        that.$toasted.show('修改头像成功')
        var u = getCookie('user')
        u.head = path
        saveCookie('user', u)
        that.user.head = path
      })
    },
    OSSUploadSuccess(r) {
      if (r && r != '') {
        this.updateAvatar(r.res.requestUrls[0])
      }
    },
    getSTS() {
      this.$api.get(this.$global.resourceApiPath, '/common/getSTS', {}, r => {
        let STS = [r.data.expiration, r.data.accessKeyId, r.data.accessKeySecret, r.data.securityToken, r.data.endpointClean, r.data.bucket, r.data.region]
        this.uploadOSSConf.STS = STS
      })
    },
    showInfo() {
      var that = this
      var d = []
      this.getMemberByUserId(getCookie('user').id).then((r) => {
        if (r) {
          d = r
        }
        this.$modal.show(ModalBox, {
          opts: {
            title: '完善个人资料',
            styles: {
              width: '670',
              height: String(0.6181 * window.screen.availHeight)
            },
            currentComponent: {
              name: 'infobox',
              template: InfoBox,
              outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
              inputs: {
                data: d
              } // 向组件内传入的数据, 一般用于初始化
            },
            yes(val) { // 点击确认后要做的事情
              console.log(val)
              val.data.loginUserId = getCookie('user').id
              if (val) {
                if (val.isValidate) {
                  that.addPerson(val.data) // 调用接口保存
                  that.$toasted.show('保存成功')
                } else {
                  that.$toasted.show('请填写信息')
                  that.showInfo()
                }
              }
            },
            closed() { // 这里要判断, 只有新增状态下需要清空
            }
          }
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/modules/uc/set.vue